import React, { useEffect } from "react";
import { Route, Routes, Outlet, useParams } from "react-router-dom";
import { HomeDashboardLayout } from "../../Layout";
import sidebarMenus from "../../constants/sidebarMenus";
import { getStorage } from "../../utils/storage";

const CommonDashboard = () => {
  const routes = [...sidebarMenus()];

  useEffect(() => {
    async function userInfo() {
      const user = await getStorage();

      if (!user.accessToken) return (window.location.href = "/");
    }

    userInfo();
  });

  return (
    <HomeDashboardLayout {...useParams()}>
      <Routes>
        {routes.map((route, index) => {
          return (
            <>
              <Route key={index} path={route.path} element={route.component} />

              {route.menus && (
                <Route
                  key={index}
                  path={route.path + "/*"}
                  element={subMenusRoutes(route)}
                />
              )}
            </>
          );
        })}
      </Routes>
      <Outlet />
    </HomeDashboardLayout>
  );
};

const subMenusRoutes = (route) => {
  return (
    <Routes>
      <Route path="/" element={route.component} />
      {route.menus.map((el, index) => {
        return (
          <>
            <Route key={index} path={el.path} element={el.component} />
          </>
        );
      })}
    </Routes>
  );
};

export default CommonDashboard;
